import {createStrokeSVG} from './TEMPLATE'

export const Poll_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M4 20V10', 'M12 20V4', 'M20 20v-7'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
